import './Header.scss';
import Image from '../Image/Image';
import { selectCommon } from '../../store/commonSlice';
import { useAppSelector } from '../../store/hooks';
import Link from '../Link/Link';

type HeaderProps = {
  children?: React.JSX.Element;
};

function Header({ children }: HeaderProps): React.JSX.Element {
  const common = useAppSelector(selectCommon);
  const enquiryFormType = common.enquiryFormType;
  const enquiryTitle = common.referenceData!.enquiryFormTypes.find(
    (enquiry) => enquiry.value === enquiryFormType
  )?.label;

  const getEnquiryFormTypeDetails = (): {
    displayName: string;
    status: string;
  } => {
    let displayName = '';
    let status = '';

    switch (enquiryTitle) {
      case 'General enquiry':
        displayName = 'General enquiry';
        status = '';
        break;
      case 'Home Loan':
      case 'Home Loan Lender Enquiry':
      case 'Home Loan Apply Online':
        displayName = 'Home loan';
        status = 'application';
        break;
      case 'Personal Loan':
        displayName = 'Personal loan';
        status = 'enquiry';
        break;
      case 'Hardship Enquiry':
        displayName = 'Hardship enquiry';
        break;
      case 'Financial Planning':
        displayName = 'Financial planning';
        status = 'enquiry';
        break;
    }
    return { displayName, status };
  };

  const enquiryFormTypeDetails = getEnquiryFormTypeDetails();

  return (
    <header>
      <div className='header'>
        <ul className='header__list'>
          <li>
            <Link href='https://www.newcastlepermanent.com.au/'>
              <Image
                classes='header__logo'
                alt='NP logo'
                name='npbs-logo.svg'
                width='118'
                height='40'
              />
            </Link>
          </li>
          <li className='header__divider'></li>
          {children ? (
            <li className='header__enquiry'>
              <span className='header__enquiry-name'>{children}</span>
            </li>
          ) : (
            <li className='header__enquiry'>
              <span className='header__enquiry-name'>
                {enquiryFormTypeDetails.displayName}
              </span>
              <br />
              <span>{enquiryFormTypeDetails.status}</span>
            </li>
          )}
        </ul>
      </div>
    </header>
  );
}

export default Header;
